/**
 * Page component.
 */

/* eslint-disable no-inline-comments */
/* eslint-disable react/jsx-no-literals */
import './_page.scss';
import { ApplicationContext } from '../../common/context';
import { Button, Col, Row } from 'antd';
import { FormattedMessage } from "react-intl";
import React, { useContext } from 'react';
import Sidebar from '../sidebar/sidebar';
import Slick from '../slick/slick';

let id = 0;

const Page = () => {
  const context = useContext(ApplicationContext);
  const prefix = context.isMatrix ? 'matrix' : 'evaluation';
  const tab = '2';
  const path = `${prefix}.${tab}`;
  const selectedTab = context.tab;

  const increment = () => {
    id = ++id;

    return id;
  };

  return (
    <div className={`page-form${context.isEvaluation ? ' page-form--evaluation' : ''}`}>
      <Row>
        <Col span={24}>
          <div className={'page-form__header'}>
            <div className={'page-form__header-left'}>
              <a href={'/'}>
                <img
                  alt={'cotec - matriz'}
                  src={'cotec-logo.svg'}
                />
              </a>

              <p className={'page-form__header__label'}>{context.getOption(`${path}.title`)}</p>

              <p className={'page-form__header__title'}>{context.getOption(`${path}.subtitle`)}</p>
            </div>
            {selectedTab === '2' ? <Button
              onClick={() => context.addColumn(increment())}
              type={'tertiary'}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
              <FormattedMessage id="project.add"/>
            </Button> : null
            }
            {selectedTab === '3' ? <div className={'page-form__label'}>
              <div className={'page-form__label__circle page-form__label__circle--green'} />
              <p>
                <FormattedMessage id="page.advance"/>
              </p>

              <div className={'page-form__label__circle page-form__label__circle--yellow'} />
              <p>
                <FormattedMessage id="page.review"/>
              </p>

              <div className={'page-form__label__circle page-form__label__circle--red'} />
              <p>
                <FormattedMessage id="page.delete"/>
              </p>
            </div> : null
            }
          </div>
        </Col>
      </Row>

      <div className={'page-form__form-wrap'}>
        <div className={'page-form__form-wrap-left'}>
          <Sidebar />
        </div>
        <div className={'page-form__form-wrap-right'}>
          <Slick />
        </div>
      </div>
    </div>
  );
};

export default Page;
